import React from 'react';
import classNames from 'classnames';

import css from './VerifiedBadge.module.css';

/**
 * Small badge showing that a listing's provider has been verified as a member
 * of a professional association, e.g. "Vérifié RMPQ".
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string} props.label the text to display, e.g. "Vérifié RMPQ"
 * @returns {JSX.Element} verified badge
 */
const VerifiedBadge = props => {
  const { className, rootClassName, label } = props;
  const classes = classNames(rootClassName || css.root, className);

  return <span className={classes}>{label}</span>;
};

export default VerifiedBadge;
